<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-container">
        <span class="nav-prompt">~/portfolio $</span>
        <div class="nav-links">
          <router-link to="/" class="nav-link">home</router-link>
          <router-link to="/career" class="nav-link">career</router-link>
          <router-link to="/projects" class="nav-link">projects</router-link>
          <router-link to="/blog" class="nav-link">blog</router-link>
        </div>
      </div>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #1a1a1a;
  color: #d4d4d4;
  font-family: 'Fira Code', monospace;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #2d2d2d;
  padding: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 1rem;
}

.nav-prompt {
  color: #4ec9b0;
  margin-right: 1rem;
  font-weight: 500;
}

.nav-links {
  display: flex;
  gap: 1rem;
}

.nav-link {
  color: #9cdcfe;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  background-color: #3d3d3d;
}

.router-link-active {
  background-color: #3d3d3d;
  color: #4ec9b0;
}

@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500;600&display=swap');
</style>
